import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seatFilterTickets'
})
export class SeatFilterTicketsPipe implements PipeTransform {
  transform(ancillaries: any): string {
    if (!ancillaries || typeof ancillaries !== 'object') return 'No Seat';
    const result = Object.entries(ancillaries)
      .flatMap(([key, items]: [string, any[]]) =>
        items
          .filter(i => i?.type === 'seat' && i?.code)
          .map(i => `(${i.code}, <small>${key}</small>)`)
      );
    return result.length ? result.join('<br>') : 'No Seat';
  }
}
